import React, { useEffect } from "react";
import Navbarsticky from "./NavbarSticky";
import { Container } from "react-bootstrap";
import Footer from "./Footer";
import {
  FaUserCircle,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../store/slices/auth";

export default function Profileaccount() {
  const dispatch = useDispatch();

  const { user, loading } = useSelector((state) => state.auth);

  /* Fetch profile on page load */
  useEffect(() => {
    if (!user?.data) {
      dispatch(getProfile());
    }
  }, [dispatch]);

  return (
    <>
      <Navbarsticky />

      <div className="profileaccount-container"></div>
      <div className="profileacc-header-bg"></div>

      <Container className="profileacc-wrapper">
        <div className="profileacc-card shadow-lg">
          {/* Avatar */}
          <div className="profileacc-avatar">
            {user?.data?.imageUrl ? (
              <img
                src={user.data.imageUrl}
                alt="Profile"
                className="profileacc-avatar-img"
              />
            ) : (
              <FaUserCircle className="profileacc-avatar-icon" />
            )}
          </div>

          {/* Name */}
          <h2 className="profileacc-username">
            {loading ? "Loading..." : user?.data?.name || "—"}
          </h2>

          <hr className="profileacc-divider" />

          {/* Details */}
          <div className="profileacc-details">
            <div className="profileacc-detail-item">
              <FaEnvelope className="profileacc-detail-icon" />
              <span>{user?.data?.email || "—"}</span>
            </div>

            <div className="profileacc-detail-item">
              <FaPhoneAlt className="profileacc-detail-icon" />
              <span>{user?.data?.mobileNumber || "—"}</span>
            </div>

            <div className="profileacc-detail-item">
              <FaMapMarkerAlt className="profileacc-detail-icon" />
              <span>{user?.data?.address || "—"}</span>
            </div>
          </div>
        </div>
      </Container>

      <Footer />
    </>
  );
}
